import PropTypes from 'prop-types';
import React from 'react';

/*
{"current":{"target":100.25,"stop":0.0},
"isOptionPosition":false,
"targets":[
  {"target":100.25,"pctOfPosition":0.25,"key":859922261},
  {"target":100.5,"pctOfPosition":0.25,"key":1032234829},
  {"target":100.75,"pctOfPosition":0.25,"key":968438821},
  {"target":101.0,"pctOfPosition":0.25,"key":2092674422}
],
  "stops":[
    {"stop":0.0,"key":"0|0"},
    {"stop":99.75,"key":1079570432},
    {"stop":100.25,"key":1079578624},
    {"stop":100.5,"key":1079582720},
    {"stop":100.75,"key":1079586816}]} 	}
*/
export const CandleMagnitudeWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'CANDLE_MAGNITUDE',
    category: 'Exit',
    type: 'Candle Magnitude',
    domain: 'Underlying',
  };
  const currentBracket = softOrder.current; //object {target: 1, stop: 2}
  const isOptionPosition = softOrder.isOptionPosition;
  const targets = softOrder.targets; //array [{target:1, pctOfPosition:2, key: 3}, {target:1, pctOfPosition:2, key: 3}]
  const stops = softOrder.stops; //array [{stop:1, key: 3}, {stop:1, key: 3}]
  return (
    <Component
      details={details}
      currentBracket={currentBracket}
      isOptionPosition={isOptionPosition}
      targets={targets}
      stops={stops}
      {...rest}
    />
  );
};

CandleMagnitudeWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    current: PropTypes.any,
    isOptionPosition: PropTypes.any,
    stops: PropTypes.any,
    targets: PropTypes.any
  })
};
